import { queryOptions } from '@tanstack/react-query'

import { questionPoolListKey } from './question-pool.constants'
import { getQuestionPoolList } from './question-pool.service'
import type { TQuestionPoolStatus } from './question-pool.types'

export function questionPoolListQueryOptions(status?: TQuestionPoolStatus) {
  return queryOptions({
    queryKey: questionPoolListKey(status),
    queryFn: () => getQuestionPoolList(status),
    staleTime: 5 * 60 * 1000,
  })
}
